const FALLBACK_ROW_ID_KEYS: readonly string[] = ['id', 'number', 'water_number', 'organization_id']

const syntheticRowIds = new WeakMap<object, string>()
let syntheticRowIdCounter = 0

const nextSyntheticRowId = () => `__row-${++syntheticRowIdCounter}`

export const resolveRowId = (data: unknown, rowIdKey?: string): string => {
   if (!data || typeof data !== 'object') return nextSyntheticRowId()

   const row = data as Record<string, unknown>
   const keys = rowIdKey ? [rowIdKey, ...FALLBACK_ROW_ID_KEYS] : FALLBACK_ROW_ID_KEYS

   for (const key of keys) {
      const value = row[key]
      if (value !== undefined && value !== null && value !== '') return String(value)
   }

   const existing = syntheticRowIds.get(row)
   if (existing) return existing

   const generated = nextSyntheticRowId()
   syntheticRowIds.set(row, generated)
   return generated
}
